import { theme } from "antd";

const { defaultAlgorithm } = theme;

const customTheme = {
  algorithm: defaultAlgorithm,
  token: {
    colorPrimary: "#EC6219",
    navBgColor: "#fff",
    borderRadius: 6,
  },
};

export default customTheme;
